import { HttpErrorResponse } from '@angular/common/http';
import { createAction, props } from '@ngrx/store';

import { PartnershipValidation, ValidatePartnershipCard } from '@models/swagger';
import { PartnershipValidationStepParams } from './service';

export enum PartnershipValidationStepActions {
  Failure = '[Application Utilities PartnershipValidationStep] Failure',
  Request = '[Application Utilities PartnershipValidationStep] Request',
  Success = '[Application Utilities PartnershipValidationStep] Success',
  Reset = '[Application Utilities PartnershipValidationStep] Reset',
}

export const PartnershipValidationStepFailure = createAction(
  PartnershipValidationStepActions.Failure,
  props<{ error: HttpErrorResponse }>()
);

export const PartnershipValidationStepRequest = createAction(
  PartnershipValidationStepActions.Request,
  props<{ body: ValidatePartnershipCard; parameters?: PartnershipValidationStepParams }>()
);

export const PartnershipValidationStepSuccess = createAction(
  PartnershipValidationStepActions.Success,
  props<{ data: PartnershipValidation }>()
);

export const PartnershipValidationStepReset = createAction(PartnershipValidationStepActions.Reset);
